// @ts-nocheck

import React from 'react';
import { Form } from 'react-bootstrap';
import GiftBanner from 'sharedComponents/GiftBanner';
import Navbar from 'sharedComponents/Navbar';
import Payment from 'sharedComponents/Payment'; // moved from ./sections to sharedComponents
import Spinner from 'sharedComponents/Spinner';
import Testimonials from 'sharedComponents/Testimonials';

import EventRegistration from './sections/EventRegistration'
import CharityRun from './sections/CharityRun';
import Contact from './sections/Contact';
import Options from './sections/Options';
import PaymentProfiles from './sections/PaymentProfiles';

import type { DonateProps, DonateState } from './Donate';
/**
 * Donate Express Page
 * 
 * Simplified donation flow with:
 * - Only firstName, lastName, and email fields
 * - Billing address matches contact address (hidden checkbox, default true)
 * - Only credit card, apple pay, and google pay payment options
 * 
 */
class DonateExpress extends React.Component<DonateProps, DonateState> {

  componentDidMount() {
    // Ensure credit card payment type is selected and form is expanded for express flow
    const { 
      setTypePayment, 
      setShowDetails, 
      paymentType
    } = this.props;
    
    // Set payment type to card if not already set
    if (setTypePayment && paymentType !== 'card') {
      setTypePayment('card');
    }
    // Expand payment form
    if (setShowDetails) {
      setShowDetails(true);
    }
    // Note: Donation type and amount are handled by Options component when flow="express" prop is passed
  }

  // componentDidUpdate removed - allow switching between card, applePay, googlePay
  // The expressLayoutConfig.paymentDetails.excludedMethods already restricts to valid options
  // and initialPaymentType: 'card' sets the default

  render() {
    const {
      campaignId, 
      customer, 
      enableEvents,
      enableEventRegistrations,
      enableCharityRun,
      getAccessTokenSilently, 
      guestMode, 
      initialUrlParams, 
      isAdminTerminal,
      loading, 
      loadingCustomer, 
      site, 
      loggedInWithPhone,
    } = this.props

    // Layout config for express flow
    const expressLayoutConfig = {
      contact: {
        billingAddressCheckbox: {
          visible: false, // Hide the billing address checkbox
        },
        firstName: {
          xs: 6, // First name: xs-6
          sm: 6, // First name: sm-6
          md: 6, // First name: md-6
        },
        lastName: {
          xs: 6, // Last name: xs-6
          sm: 6, // Last name: sm-6
          md: 6, // Last name: md-6
        },
        email: {
          xs: 12, // Email: xs-12
          sm: 12, // Email: sm-12
          md: 12, // Email: md-12
        },
      },
      paymentDetails: {
        excludedMethods: ['bank_ach_stripe', 'bank_ach'], // Only show card, applePay, googlePay
        initialPaymentType: 'card', // Default select credit card payment type
      },
    };

    return (
      <div 
        className={[
          'app-form-body',
          guestMode ? ' guest-mode' : '',
          enableEvents ? ' event-registration-container' : ''
        ].join('')} 
        style={{ 
          position: 'relative',
          paddingRight: 0, 
          maxWidth: 972
        }}
      >
        <style>
          {`.main-image {
            display: none;
          } .donate-headline {
            padding-top: 0px !important;
            margin-top: 0px !important;
          } #header {
            display: none !important;
          } .footer-copyright {
            display: none !important;
          } .express-flow-main-logo-mobile {
            display: none !important;
          } .app-form-body {
            border-radius: 16px !important;
          } .form-container {
            border-radius: 16px !important;
          }
          @media (max-width: 972px) {
            .app-form-body {
              margin-top: 0px !important;
              margin-bottom: 0px !important;
            }
            .form-container {
              border-radius: 0px !important;
              margin-bottom: 0px !important;
            }
          }
          @media (max-width: 768px) {
            .express-flow-main-logo-mobile {
              display: block !important;
            }
            .express-flow-main-logo-desktop {
              display: none !important;
            }
          }`}
        </style>
        {(!enableEvents || enableEvents && enableEventRegistrations) && (
        <div className={`form-container donate`}>
          {loading && 
            <Spinner mask/> 
          }
          <Form>
            <Options 
              {...this.props}
              guestMode={guestMode} 
              isAdminTerminal={isAdminTerminal}
              initialDonationType="one-time"
              flow="express"
              onlyShowTypes={['monthly', 'one-time']}
              plans={{
                'one-time': [25, 50, 100, 500, null],
                'default_one-time_amount': 50,
                'monthly': [25, 50, 100, 250, null],
                'default_monthly_amount': 50,
                'skip_initial_param_amount': true,
              }}
            />
            <Contact
              {...this.props}
              guestMode={guestMode} 
              editMode={true}
              visibleInputs={['firstName', 'lastName', 'email']}
              layoutConfig={expressLayoutConfig}
              flow="express"
            />
            {customer ? 
              <PaymentProfiles 
                {...this.props}
                getAccessTokenSilently={getAccessTokenSilently} 
              /> 
              : null 
            }
            <Payment 
              {...this.props}
              getAccessTokenSilently={getAccessTokenSilently} 
              withTitle={!customer && !loadingCustomer} 
              guestMode={guestMode}
              layoutConfig={expressLayoutConfig}
              flow="express"
            />
          </Form>
        </div>
        )}
        <div id="save-the-storks-gift" />
        {/* {guestMode && (
          <>
            {!isAdminTerminal && 
              <GiftBanner 
                cid={campaignId || initialUrlParams.cid} 
              />
            }
            <Testimonials site={site} cid={campaignId || initialUrlParams.cid} />
          </>
        )} */}
      </div>
    )
  }
}

export default DonateExpress

